/**
 * Duration for undo toast notifications in milliseconds.
 * Used for both toast display and setTimeout delay.
 */
export const UNDO_TIMEOUT_MS = 5000;

/** Maximum number of actions to display before "See more" */
export const MAX_VISIBLE_ACTIONS = 5;
